let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aONsY")).then(() => parcelRequire('bqE5a'));